var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"15px 15px 0 0"}},[_c('div',{staticClass:"close_icon",class:{'big_icon' : !_vm.smallIcon},on:{"click":function($event){return _vm.$emit('hide-modal')}}},[_c('img',{attrs:{"src":'/images/smtpConfigImages/closeModal.svg'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }